import { Base } from "../Base";
export var Flaw;
(function (Flaw) {
    var _a;
    Flaw.type = Base.isly.object({
        name: Base.isly.string().readonly(),
        description: Base.isly.string().optional().readonly(),
        condition: Base.isly.string().array().optional(),
        flaws: Base.isly
            .intersection(Base.isly.lazy(() => Flaw.type, "isly.Flaw"), Base.isly.union(Base.isly.object({ index: Base.isly.number().optional() }), Base.isly.object({ property: Base.isly.string() })))
            .optional(),
    }, "isly.Flaw");
    _a = Flaw.type.bind(), Flaw.is = _a.is, Flaw.flawed = _a.flawed;
})(Flaw || (Flaw = {}));
//# sourceMappingURL=index.js.map